export const ENLANG ="en";
export const TRLANG = "tr";
export const EN_ROUTE = "/en";
export const TR_ROUTE = "/tr";
